<template>
  <Modal :id="'cmp-add-custom-checklist'" @cancelled="onCancel" class="cmp-contacts-groups-add_group">
    <template slot="header">New Group</template>

    <template slot="body">
      <!-- <v-text-field :height="5" v-model="checklist_title" label="Checklist Title" /> -->
      <div class="form-group">
        <TextField
          :id="'group'"
          v-bind="textFieldConfig"
          v-model="groupNew.group_name"
          isModel
          required
          :placeholder="$t('name')"
          @validated="onValidation"
          immediateValidation
        ></TextField>
        <TextField
          :id="'comment'"
          v-bind="textFieldConfigNoValidate"
          v-model="groupNew.comment"
          isModel
          :placeholder="$t('description')"
        ></TextField>
        <div class="forward-checkbox" style="margin-top:10px">
            <div class="checkboxcontainer">
              <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="'cb_private'"
                    :id="'cb_private'"
                
                    @click="e => onPrivateCheckBoxChanged(e)"
                  />
                  <div class="checkmark"></div>
              </div>
            </div>
            <div class="checkbox-label">
                <span style="margin-left:0px;margin-top:0px">
                  {{ $t('private') }}
                </span>

            </div>
      </div>
  
      </div>
    </template>

    <template slot="options">
        <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
        <button   :disabled="!isFormValid"
        :class="{ disabled: !isFormValid }" class="dt-button v1 s6" @click.stop="onAddNewGroup">{{$t('add_new_group')}}</button>
   
    </template>
  </Modal>
</template>

<script>
import TextField from "@plugins/text-field/text-field";
import { ContactGroupsService } from "../../services/contact_groups.service";
import { contactGroupsListLDTRoutes } from "../../router/routes";
import * as types from "../../store/groups/types";
import { ContactStoreNamespace } from "../../store/index";
import Modal from "../../../../dt-plugins/modal/modal";
export default {
  components: {
    TextField,
    Modal
  },
  props: [],
  data: function() {
    return {
      isCommaAdded: false,
      emailsLocal: "",
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        statusInside: true
      },
      textFieldConfigNoValidate: {
        height: 42,
        showEditIconOnHover: false,
        box: true
      },
      groupNew: {
        group_name: "",
        comment: "",
        private: 0
      },
      validationResult: {}
    };
  },
  watch: {},
  computed: {isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },},
  methods: {
    onCancel: function() {
      this.$emit("cancelled");
    },
    onPrivateCheckBoxChanged(e) {
      this.groupNew.private = e.target.checked ? 1 : 0;
    },
    onValidation: function(id, validationResult) {
      this.$set(this.validationResult, id, validationResult);
    },
    onAddNewGroup() {
      if (this.groupNew.group_name != "") {
        ContactGroupsService.addNewContactGroup(this.groupNew).then(res => {
          this.$router.push({
            name: contactGroupsListLDTRoutes.names.tab,
            params: {
              group_id: res.data.group_id,
              tab: "overview"
            }
          });

          this.$store.dispatch(
            `${ContactStoreNamespace}/${types.SelectedContactGroup.SET.SINGLE}`,
            {
              group: res.data
            }
          );
          this.$store.dispatch(
            `${ContactStoreNamespace}/${types.ContactGroups.FETCH.ALL}`
          );
        });
      }
    }
  }
};
</script>

<style lang="scss" >
.cmp-contacts-groups-add_group{
      .forward-checkbox {
        margin-left:10px ;    
        display: flex;
        flex-direction: row;
        margin-left: 5px;
      .checkboxcontainer {
        max-width: 50px;
        margin-right: 10px;
        margin-top: auto;
        margin-bottom: auto;
      }
      .checkbox-label{
        margin-top: -1px;
      }
    }
  .dt-modal--body {
    margin-left: 0px;
  }

  .contact-search {
    height: 30px;
    width: 290px;
  }

  .contact-table {
    margin-top: 10px;

    tbody {
      min-height: 380px;
    }
  }

  .dt-table2 {
    --body-height: 380px;
    --row-height: 28px;

    display: flex;
    flex-direction: column;

    &--head {
    }
    th.dt-table2--column {
      text-align: left;
      color: #828282;
      font-weight: 400;
    }
    &--body {
      background: #f8f8f8;

      display: flex;
      flex-direction: column;

      border: 1px solid var(--sprt-5);
      border-radius: 3px;

      .dt-table2--row {
        border-bottom: 1px solid var(--sprt-7);
      }

      max-height: var(--body-height);
      overflow: auto;
    }
    &--row {
      display: flex;
      flex-direction: row;
      padding: 5px;
      margin: 0px 10px;

      min-height: var(--row-height);
      cursor: pointer;

      &:hover {
        background: rgb(235, 235, 235);
      }
    }
    &--column {
      flex: 1;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .dt-modal--options {
    justify-content: space-between;
    button{
        &:first-child {
          
           // margin-right: 10px;
        }
        &:last-child {
      
           // margin-left:0px 10px;
        }
    }
  }
}

</style>
